import React from 'react';
import PropTypes from 'prop-types';
import AmenityIcon from '../../../../components/stateless/AmenityIcon';
import Icon from '../../../../../modules/react/components/stateless/Icon';
import { AMENITIES } from '../../../../../modules/amenities';
import style from './AmenityCustomization.scss';

const propTypes = {
  title: PropTypes.string.isRequired,
  updateTitle: PropTypes.func.isRequired,
  amenities: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateAmenityCustomization: PropTypes.func.isRequired,
};

const defaultProps = {};

const AmenityCustomization = ({
  title,
  amenities,
  updateTitle,
  updateAmenityCustomization,
}) => {
  const updateDescription = (amenityName, description) => {
    if (description.length > 100) {
      return;
    }

    const newAmenities = amenities.map(amenity => (amenity.name === amenityName
      ? { ...amenity, description } : amenity));
    updateAmenityCustomization(newAmenities);
  };

  const moveAmenity = (amenityName, num, e) => {
    e.stopPropagation();
    e.preventDefault();

    const idx = amenities.findIndex(amenity => amenity.name === amenityName);
    const amenity = amenities.splice(idx, 1)[0];
    amenities.splice(idx + num, 0, amenity);

    updateAmenityCustomization(amenities);
  };

  return (
    <div>
      <div>
        <div className={style.title}>
          Title
        </div>
        <input
          onChange={e => updateTitle(e.target.value)}
          value={title}
          className={style.titleInput}
        />
      </div>
      <div>
        <div className={style.infoBold}>
          Arrange the amenities in the order you’d like them to display and customize optional
           amenity descriptions.
        </div>
        <div className={style.infoMuted}>
          These will display when a user clicks on an amenity icon.
        </div>
      </div>
      <div className={style.customizationContainer}>
        {amenities.map(({ name, description }, i) => {
          const descriptionProps = {
            onChange: e => updateDescription(name, e.target.value),
            value: description,
            className: style.amenityDescription,
          };

          const upBtnProps = {
            onClick: e => moveAmenity(name, -1, e),
            disabled: i === 0,
            className: style.arrow,
          };

          const downBtnProps = {
            onClick: e => moveAmenity(name, 1, e),
            disabled: i === amenities.length - 1,
            className: style.arrow,
          };

          return (
            <div key={name} className={style.amenityRow}>
              <div className={style.nameIconContainer}>
                <span className={style.amenityIcon}>
                  <AmenityIcon
                    id={(AMENITIES.find(amenity => amenity.name === name) || {}).id}
                    label={name}
                  />
                </span>
                <span className={style.amenityName}>
                  {name}
                </span>
              </div>
              <div className={style.descriptionContainer}>
                <input {...descriptionProps} />
                <div className={style.arrowContainer}>
                  <button {...upBtnProps} type="button">
                    <Icon id="filter-arrow-up" label={`move ${name} up`} />
                  </button>
                  <button {...downBtnProps} type="button">
                    <Icon id="filter-arrow-down" label={`move ${name} down`} />
                  </button>
                </div>
              </div>
              <div className={style.counter}>
                {`${description.length}/100 Characters`}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

AmenityCustomization.propTypes = propTypes;
AmenityCustomization.defaultProps = defaultProps;

export default AmenityCustomization;
